import { RouterModule, Routes } from '@angular/router';
import { AdminViewComponent } from './adminView/adminView.component';
import { StoresComponent } from './stores/stores.component';
import { AdminPlanComponent } from './admin-plan/admin-plan.component';
import { AdminLeadComponent } from './admin-lead/admin-lead.component';
import { AdminMetricsComponent } from './admin-metrics/admin-metrics.component';
import { AdminFinanceComponent } from './admin-finance/admin-finance.component';
import { AdminPipeComponent } from './admin-pipe/admin-pipe.component';
import { NgModule } from "@angular/core";

const routes: Routes = [{
    path: '',
    children: [
        {
            path: 'adminview',
            component: AdminViewComponent
        },
        {
            path: 'stores',
            component: StoresComponent
        },
        {
            path: 'admin-plan',
            component: AdminPlanComponent
        },
        {
            path: 'admin-lead',
            component: AdminLeadComponent
        },
        {
            path: 'admin-metrics',
            component: AdminMetricsComponent
        },
        {
            path: 'admin-finance',
            component: AdminFinanceComponent
        },
        {
            path: 'admin-pipe',
            component: AdminPipeComponent
        }]
}];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class DashboardRoutes { }
